// extracted by mini-css-extract-plugin
export default {"table_stat":"styles_table_stat__g9Izz","td_select_transparent":"styles_td_select_transparent__8cnGI","td_select":"styles_td_select__2pdI5","active":"styles_active__f3SUd"};